var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mag-footer"},[(_vm.footer.text)?[_vm._v(" "+_vm._s(_vm.footer.text)+" "),_c('br')]:_vm._e(),_vm._v(" "+_vm._s('© 2011-' + new Date().getFullYear() + ' MAG.travel Проект Master-Agent. Все права защищены. +7 (495) 6-020-020, info@mag.travel')+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }